<template>
  <div id="Tab" class="sun">
    <div class="nav-tabs">
      <button
        v-for="(tab, i) in tabs"
        :key="i"
        @click="selected = i"
        :class="['tab-btn', { active: selected === i }]"
      >
        {{ tab }}
      </button>
    </div>
    <component :is="selected" class="tab"></component>
  </div>
</template>

<script>
import Talk from './List'
import Notice from '../notices/List'

let self

export default {
  name: 'Tab',
  components: {
    Talk,
    Notice
  },
  data: function () {
    return {
      tabs: {
        'Talk': '사장님 일상',
        'Notice': '공지사항'
      },
      selected: 'Talk'
    }
  },
  async created() {
    self = this
    self.$store.commit('ui/headerTitle', '나우 톡톡!')
    if (self.$route.params.component) {
      this.selected = self.$route.params.component
    }
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
  #Tab {
    width: 100%;
    background-color: #f6f6f6;
    max-width: inherit;
    .nav-tabs {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      margin-bottom: 15px;
      width: 100%;
      height: 56px;
      button {
        color: #8a94a2;
        font-size: 17px;
        font-weight: 600;
        letter-spacing: normal;
        width: calc(100%/3);
        height: 100%;
        &.active {
          color: #333333;
          border-bottom: 2px solid #333333;
          font-weight: 800;
        }
      }
    }
  }
</style>
